import { Routes } from '@angular/router';
import { AppService, authGuard, JavniLayout, Layout, publicGuard } from 'shared-components';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'vstopnaStran',
  },

  // javne strani
  {
    path: '',
    component: JavniLayout,
    children: [
      {
        path: 'vstopnaStran',
        canActivate: [publicGuard],
        loadComponent: () => import('./vstopna-stran/vstopna-stran').then((c) => c.VstopnaStran),
      },
      {
        path: 'pravnePodlage',
        loadComponent: () => import('./javne-strani/javne-strani').then((c) => c.JavneStrani),
        data: { naslov: 'Pravne podlage', servis: 'PravnePodlage' },
      },
      {
        path: 'politikaZasebnosti',
        loadComponent: () => import('./javne-strani/javne-strani').then((c) => c.JavneStrani),
        data: { naslov: 'Politika zasebnosti', servis: 'PolitikaZasebnosti' },
      },
      {
        path: 'kontakt',
        loadComponent: () => import('./javne-strani/javne-strani').then((c) => c.JavneStrani),
        data: { naslov: 'Kontakt', servis: 'Kontakt' },
      },
      {
        path: 'obvNedelovanjeApk',
        loadComponent: () =>
          import('./obv-nedelovanje-apk/obv-nedelovanje-apk.component').then(
            (c) => c.ObvNedelovanjeApkComponent,
          ),
      },
    ],
  },

  // auth strani
  {
    path: '',
    component: Layout,
    children: [
      {
        path: 'zacetnaStran',
        loadComponent: () => import('./zacetna-stran/zacetna-stran').then((c) => c.ZacetnaStran),
        canActivate: [authGuard],
        data: {
          role: AppService.baseAppRole,
          breadcrumb: 'Začetna stran',
        },
      },
    ],
  },

  {
    path: 'access-denied',
    loadComponent: () => import('arsktrp-shared-components').then((c) => c.AccessDenied),
  },
  {
    path: 'not-found',
    loadComponent: () => import('arsktrp-shared-components').then((c) => c.NotFound),
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];
